import sortBy from 'lodash/sortBy';

import { Transcript } from '@/resources/Transcript';

export const sortTranscriptsByLanguagePosition = (transcripts: Array<Transcript> = []) => {
  return sortBy(transcripts, (transcript) => {
    return transcript.language.position;
  });
};
